import { CellClassParams, ICellRendererParams } from '@ag-grid-community/core';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import { first } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import {
  listDriverCustomDistributionQuery,
  listDriverPatientDistributionsQuery,
  listDriverSiteDistributionsQuery,
} from '@shared/services/gql.service';
import { DateUtils } from '@shared/utils';

dayjs.extend(minMax);

type Distribution =
  | listDriverCustomDistributionQuery
  | listDriverPatientDistributionsQuery
  | listDriverSiteDistributionsQuery;

type Timeline = {
  endDate: string;
  startDate: string;
};

@Injectable({ providedIn: 'root' })
export class DistributionTimelineService {
  getDistributionTimeline(currentTimeline: Timeline, distributions: Distribution[]): Timeline {
    return {
      endDate: this.getEndDate(currentTimeline.endDate, distributions),
      startDate: this.getStartDate(currentTimeline.startDate, distributions),
    };
  }

  getEndDate(timelineEndDate: string, distributions: Distribution[]) {
    const distributionEndMonth = distributions[distributions.length - 1]?.distribution_month;

    if (!distributionEndMonth) {
      return timelineEndDate;
    }

    return dayjs(timelineEndDate).isBefore(distributionEndMonth)
      ? distributionEndMonth
      : timelineEndDate;
  }

  getStartDate(timelineStartDate: string, distributions: Distribution[]) {
    const distributionStartMonth = first(distributions)?.distribution_month;

    if (!distributionStartMonth) {
      return timelineStartDate;
    }

    return dayjs(timelineStartDate).isAfter(distributionStartMonth)
      ? distributionStartMonth
      : timelineStartDate;
  }

  static isMonthNoLongerInTimeline(
    params: CellClassParams | ICellRendererParams,
    distributionDate: string,
    timeline$: BehaviorSubject<Partial<Timeline>>
  ) {
    if (params.data?.distribution_month === 'TOTAL') return false;

    return !DateUtils.isInRange(distributionDate, timeline$.getValue());
  }
}
